// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/breadcrumbs/stylesheets/index.scss
 ** module id = 401
 ** module chunks = 1
 **/